/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/location-tile/custom-elements';

import { defineCustomElement as defineOsdsLocationTile } from '@ovhcloud/ods-stencil/components/location-tile/custom-elements/osds-location-tile.js';

export const OsdsLocationTile = /*@__PURE__*/createReactComponent<JSX.OsdsLocationTile, HTMLOsdsLocationTileElement>('osds-location-tile', undefined, undefined, defineOsdsLocationTile);
